import React from 'react';
import { Select } from 'antd';

const Option = Select.Option;

const TypeSelect = ({ title, selected = true, options, onChange, className, value }) => {
	if (!options) return null;
	return <span className={className}>
    {title}
		<Select disabled={!selected} defaultValue={options[0]}
		        style={{ width: 120 }} onChange={onChange}>
            {options.map((o, i) => <Option key={i} value={o}>{o}</Option>)}
        </Select>
    </span>;
};

export default TypeSelect;


// WEBPACK FOOTER //
// ./src/components/AnswerTypeSelect/TypeSelect.js